Object.defineProperty(exports,"__esModule",{value: true});
exports.default=window.GrimoireJS&&window.GrimoireJS.lib.animation?window.GrimoireJS.lib.animation.Animation.AnimationFactory:undefined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/grimoirejs-animation/ref/Animation/AnimationFactory.js
// module id = 32
// module chunks = 0